import React, { useState } from 'react';

import { Box, Button } from '@mui/material';

import OhsModuleHeader from 'global-components/register/OhsModuleHeader';

import SysFieldCusvalGroupFixedValue from './SysFieldCusvalGroupFixedValue';
import SysFieldCusvalGroupRealData from './SysFieldCusvalGroupRealData';

function SysFieldCusvalGroupTestMain() {
  const [activeTab, setActiveTab] = useState(2);

  const tabs = [
    {
      id: 1,
      name: 'Default',
      component: <SysFieldCusvalGroupFixedValue />,
    },
    {
      id: 2,
      name: 'Actual Process',
      component: <SysFieldCusvalGroupRealData />,
    },
  ];

  return (
    <Box>
      <OhsModuleHeader title="System Field Cusval" as="h3" />

      {/* Header */}
      <Box width="100%" display="flex" mb={4}>
        {tabs.map((tab) => {
          return (
            <Box key={tab.id} mr={1}>
              <Button
                onClick={() => setActiveTab(tab.id)}
                variant={activeTab === tab.id ? 'contained' : 'outlined'}
              >
                {tab.name}
              </Button>
            </Box>
          );
        })}
      </Box>

      {/* Content */}
      <Box width="100%">{tabs.find((tab) => tab.id === activeTab)?.component}</Box>
    </Box>
  );
}

export default SysFieldCusvalGroupTestMain;
